'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _tracking = require('@spp/tracking');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _MastheadExtensionWidgets = require('../MastheadExtensionWidgets');

var _MastheadExtensionWidgets2 = _interopRequireDefault(_MastheadExtensionWidgets);

var _MastheadExtensionSubscriptionButtons = require('../MastheadExtensionSubscriptionButtons');

var _MastheadExtensionSubscriptionButtons2 = _interopRequireDefault(_MastheadExtensionSubscriptionButtons);

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = function format(date, locale) {
    var daySeparator = locale === 'nb' ? ',' : '';
    var monthSeparator = locale === 'nb' ? '.' : '';
    var localized = {
        sv: {
            days: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
            months: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
        },
        nb: {
            days: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
            months: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
        }
    };

    return '' + localized[locale].days[date.getDay()] + daySeparator + ' ' + date.getDate() + monthSeparator + ' ' + localized[locale].months[date.getMonth()] + ' ' + date.getFullYear();
}; /* eslint-disable import/no-named-as-default */
var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    SECTION: 'Masthead_Section'
};

var sectionClick = function sectionClick(engagement, url, name) {
    return function (event) {
        event.preventDefault();

        _tracking.util.actionThenRelocateWithTimeout(engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.SECTION,
            meta: { name: name, event: event }
        }), url);
    };
};

var MastheadExtensionBasicView = function MastheadExtensionBasicView(_ref) {
    var theme = _ref.theme,
        importantSections = _ref.importantSections,
        mastheadExtension = _ref.mastheadExtension,
        attributes = _ref.attributes,
        engagement = _ref.engagement;
    var widgets = mastheadExtension.widgets,
        dateLocale = mastheadExtension.dateLocale,
        loginFirst = mastheadExtension.loginFirst;


    return _react2.default.createElement(
        'div',
        { className: theme.sectionLinks },
        _react2.default.createElement(
            'div',
            { className: theme.mainDesktop },
            _react2.default.createElement(
                'span',
                { className: theme.date },
                format(new Date(), dateLocale)
            ),
            _react2.default.createElement(_MastheadExtensionWidgets2.default, {
                widgets: widgets && widgets.mastheadExtensionWidgets,
                theme: theme
            }),
            _react2.default.createElement(_MastheadExtensionSubscriptionButtons2.default, {
                theme: theme,
                mastheadExtension: mastheadExtension,
                widgets: widgets,
                attributes: attributes,
                engagement: engagement,
                loginFirst: loginFirst
            })
        ),
        _react2.default.createElement(
            'div',
            { className: theme.mainMobile },
            _react2.default.createElement(
                'nav',
                { className: theme.importantSectionsMenu },
                _react2.default.createElement(
                    'ul',
                    { className: theme.subsections, 'aria-label': 'submenu' },
                    importantSections.map(function (importantSection) {
                        return _react2.default.createElement(
                            'li',
                            { key: importantSection.url, className: theme.importantSectionsItem },
                            _react2.default.createElement(
                                _uiInternalLink2.default,
                                {
                                    link: importantSection.url,
                                    className: theme.importantSectionsLink,
                                    onClick: sectionClick(engagement, importantSection.url, importantSection.name),
                                    enableSinglePage: true
                                },
                                importantSection.name
                            )
                        );
                    })
                )
            ),
            _react2.default.createElement(_MastheadExtensionSubscriptionButtons2.default, {
                theme: theme,
                mastheadExtension: mastheadExtension,
                widgets: widgets,
                attributes: attributes,
                engagement: engagement
            })
        )
    );
};

if (process.env.NODE_ENV !== 'production') {
    MastheadExtensionBasicView.propTypes = {
        attributes: _propTypes2.default.func,
        engagement: _propTypes2.default.func,
        mastheadExtension: _propTypes2.default.shape(_props.mastheadExtensionProps).isRequired,
        importantSections: _propTypes2.default.arrayOf(_propTypes2.default.shape(_props.sectionProps)).isRequired,
        theme: _propTypes2.default.shape({
            mainMobile: _propTypes2.default.string,
            mainDesktop: _propTypes2.default.string,
            importantSectionsLink: _propTypes2.default.string,
            importantSectionsItem: _propTypes2.default.string,
            date: _propTypes2.default.string,
            subsections: _propTypes2.default.string
        })
    };
}

MastheadExtensionBasicView.defaultProps = {
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    theme: {}
};

exports.default = MastheadExtensionBasicView;
//# sourceMappingURL=MastheadExtensionBasicView.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionBasicView/MastheadExtensionBasicView.js
 ** module id = 322
 ** module chunks = 0
 **/